import React from 'react';
import {
  Card, CardContent, Box, Typography,
} from '@material-ui/core';
import { SiCodeigniter } from 'react-icons/si';
import { BorderLinearProgress, useStyles } from './styles';

const Mobilitimetro = (props) => {
  const { points } = props;
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Box className={classes.titleContainer}>
          <Box className={classes.itemsCont}>
            <SiCodeigniter style={{ color: 'red' }} size="15" />
          </Box>
          <Box className={classes.itemsCont}>
            <Typography className={classes.title}>Mobilitímetro</Typography>
          </Box>
        </Box>

        {points.map((value) => (
          <Box key={value.Documento} className={classes.barContainer}>
            <Typography className={classes.description}>
              {value.Documento}
            </Typography>

            <BorderLinearProgress
              variant="determinate"
              value={value.Peso * 100}
            />
            <Typography className={classes.description}>
              {`${(
                value.Peso * 100
              ).toFixed(2)}%`}

            </Typography>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default Mobilitimetro;
